(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crew-built-for"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crew-built-carousel')) {
    customElements.define(
      'crew-built-carousel',
      class CrewBuiltCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-crew-built-track]');
          this.dots = Array.from(this.querySelectorAll('.crew-built__dot'));
          if (!this.track || !this.dots.length) return;

          this.slides = Array.from(this.track.children);
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
        }

        disconnectedCallback() {
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          cancelAnimationFrame(this.frame);
        }

        goTo(index) {
          const slide = this.slides[index];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          let active = 0;

          // At the end of the track the last slides can't snap to the start, so force the last dot.
          if (scrollLeft + clientWidth >= scrollWidth - 2) {
            active = this.slides.length - 1;
          } else {
            const origin = this.slides[0].offsetLeft;
            let closest = Infinity;
            this.slides.forEach((slide, i) => {
              const distance = Math.abs(slide.offsetLeft - origin - scrollLeft);
              if (distance < closest) {
                closest = distance;
                active = i;
              }
            });
          }

          this.dots.forEach((dot, i) => {
            if (i === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crew-process"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crew-process-tabs')) {
    customElements.define(
      'crew-process-tabs',
      class CrewProcessTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;

          this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
          });

          // Theme editor: selecting a step block shows that step on mobile
          this.onBlockSelect = (event) => {
            const index = this.panels.indexOf(event.target);
            if (index !== -1) this.select(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onKeydown(event, index) {
          const last = this.tabs.length - 1;
          let next;
          if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
          else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = last;
          else return;

          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[i]) this.panels[i].classList.toggle('is-active', active);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crew-program-options"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crew-program-tabs')) {
    customElements.define(
      'crew-program-tabs',
      class CrewProgramTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;

          this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
          });
        }

        onKeydown(event, index) {
          const last = this.tabs.length - 1;
          let next;
          if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
          else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = last;
          else return;

          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[i]) this.panels[i].classList.toggle('is-active', active);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crew-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crew-testimonials-carousel')) {
    customElements.define(
      'crew-testimonials-carousel',
      class CrewTestimonialsCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-crew-testimonials-track]');
          if (!this.track) return;

          this.slides = Array.from(this.track.children);
          this.arrows = this.querySelector('[data-crew-testimonials-arrows]');
          this.prev = this.querySelector('[data-crew-testimonials-prev]');
          this.next = this.querySelector('[data-crew-testimonials-next]');
          this.dots = Array.from(this.querySelectorAll('.crew-testimonials__dot'));

          this.onPrev = () => this.step(-1);
          this.onNext = () => this.step(1);
          if (this.prev) this.prev.addEventListener('click', this.onPrev);
          if (this.next) this.next.addEventListener('click', this.onNext);
          this.dotHandlers = this.dots.map((dot, i) => {
            const handler = () => this.goTo(i);
            dot.addEventListener('click', handler);
            return handler;
          });

          this.onScroll = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          };
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);

          // Theme editor: bring the selected testimonial into view
          this.onBlockSelect = (event) => {
            const index = this.slides.indexOf(event.target);
            if (index !== -1) this.goTo(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.update();
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.track.removeEventListener('scroll', this.onScroll);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          this.dots.forEach((dot, i) => dot.removeEventListener('click', this.dotHandlers[i]));
          this.resizeObserver.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          cancelAnimationFrame(this.frame);
        }

        // Distance between the starts of two neighbouring cards
        slideStep() {
          if (this.slides.length < 2) return this.track.clientWidth;
          return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }

        step(direction) {
          this.track.scrollBy({ left: direction * this.slideStep() });
        }

        goTo(index) {
          const slide = this.slides[index];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft });
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const atStart = scrollLeft <= 2;
          const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

          if (this.arrows) this.arrows.hidden = atStart && atEnd;
          if (this.prev) this.prev.disabled = atStart;
          if (this.next) this.next.disabled = atEnd;

          if (!this.dots.length) return;
          const active = atEnd
            ? this.slides.length - 1
            : Math.min(this.slides.length - 1, Math.round(scrollLeft / this.slideStep()));
          this.dots.forEach((dot, i) => {
            if (i === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
